module.exports = __webpack_public_path__ + "img/jobs.74a4ca76.svg";